function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "MS-SymbolLockup");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 9,
  height: 9,
  fill: "#f25022"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 11,
  width: 9,
  height: 9,
  fill: "#00a4ef"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 1,
  width: 9,
  height: 9,
  fill: "#7fba00"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 11,
  width: 9,
  height: 9,
  fill: "#ffb900"
});

var SvgMsLogo = function SvgMsLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ms-logo.319d9b9a.svg";
export { ForwardRef as ReactComponent };